import React, { useCallback, useEffect, useState, useContext } from "react";
import { Fragment } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import {
  fetchDebtsToPayAsPropertyCuenta,
  GetMyBalance,
  fetchDebtsToPayAsPropertyOne,
  markAsPaidDebtToPayAsPropertyAdmin,
  markAsPaidDebtToPayAsPropertyAdminPass,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { Toast } from "../UI/toast/Toast";
import Loader from "../common/Loader";
import ButtonIcon from "../common/ButtonIcon";
import { faDollarSign, faSearch } from "@fortawesome/free-solid-svg-icons";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import SelectBankListItem from "../common/SelectBankListItem";
import { fetchCondominiumBanks } from "../../helpers/api/banks";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { Controller, useForm } from "react-hook-form";
import FullPagination from "../common/pagination/FullPagination";
import WizardError from "../auth/register/WizardError";
import FileUploadArea from "../common/FileUploadArea";
import SelectCuentasListItem from "../common/SelectCuentasListItem";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import classNames from "classnames";
import { fetchProperties } from "../../helpers/api/condominium";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const PropertyToPaysAdmin = ({ setRedirect, setRedirectUrl }) => {
  const moduleBase = useModuleBase();
  const { properties, id, pay } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  // `id` (condominio de esta planilla, de la URL) en vez de `selectedCondominium`
  // (el condominio activo en el selector global de la barra superior): si
  // quedaban desincronizados, el listado de bancos mostraba cuentas de OTRO
  // condominio, permitiendo elegir un bank_id que el backend no puede
  // asociar a la cuenta contable correcta de esta planilla (cae a la cuenta
  // CURRENT/ADVANCES genérica en vez de a la del banco elegido).
  const [params, setParams] = useState({
    condominiumId: id,
    search: null,
  });
  const { user } = useSelector((state) => state.auth);
  const [search, setSearch] = useState("");
  const [selectedCuenta, setSelectedCuenta] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [bank, setBank] = useState(null);
  const [fund, setFund] = useState([]);
  const [current, setCurrent] = useState([]);
  const [file, setFile] = useState(null);
  const [amount, setAmount] = useState(0);
  const [cash, setCash] = useState([]);
  const [balance, setBalance] = useState({
    data: 0,
    loading: true,
    error: null,
  });

  /*   const {
    data,
    handler: { goToPage, nextPage, perPage, previousPage },
    isLoading,
    meta,
  } = useSWRFetchPagination(fetchCondominiumBanks, params);
*/

  const [param, setParam] = useState({
    condominiumId: id,
    search: null,
  });

  const [params1, setParams1] = useState({
    condominiumId: id,
    debtsToPay: properties,
  });

  const {
    data,
    handler: { goToPage, nextPage, perPage, previousPage },
    isLoading,
    meta,
  } = useSWRFetchPaginationProperty(fetchDebtsToPayAsPropertyOne, params1);

  const {
    data: data2,
    /*     handler: {
      goToPage: goToPage2,
      nextPage: nextPage2,
      perPage: perPage2,
      previousPage: previousPage2,
    },
    isLoading: isLoading2,
    meta: meta2, */
  } = useSWRFetchPaginationProperty(fetchDebtsToPayAsPropertyOne, params1);

  const {
    data: condominiumBanks,
    handler: {
      goToPage: cbGoToPage,
      nextPage: cbNextPage,
      perPage: cbPerPage,
      previousPage: cbPreviousPage,
    },
    isLoading: cbIsLoading,
    meta: cbMeta,
  } = useSWRFetchPagination(fetchCondominiumBanks, params);

  const {
    data: data3,
    error: error3,
    isLoading: isLoading3,
    meta: meta3,
    handler: {
      goToPage: goToPage3,
      nextPage: nextPage3,
      perPage: perPage3,
      previousPage: previousPage3,
    },
  } = useSWRFetchPaginationProperty(fetchProperties, param);

  /*   const {
    data: debtsToPayData,
    handler: { goToPage: dtpGoToPage, nextPage: dtpNextPage, perPage: dtpPerPage, previousPage: dtpPreviousPage },
    isLoading: dtpIsLoading,
    meta: dtpMeta,
  } = useSWRFetchPagination(fetchDebtsToPayAsPropertyCuenta, params); */

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    setValue,
    watch,
    setError,
    control,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    if (selectedCuenta) {
      clearErrors("propertyDebtsToPay");
    }

    /*     if (!selectedProvider && !selectedProviderNotFrequent && !selectedProperty) {
      setError("provider_id", {
        message: "Debes seleccionar un proveedor",
      });
    } */
  }, [selectedCuenta]);

  useEffect(() => {
    if (selectedBankId) {
      clearErrors("bank_id");
    }
  }, [selectedBankId]);

  useEffect(() => {
    let isMounted = true;
    if (user) {
      const getBalance = async () => {
        try {
          const {
            data: { balance },
          } = await GetMyBalance();
          isMounted &&
            setBalance((prev) => {
              return { ...prev, data: balance, loading: false };
            });
        } catch (error) {
          isMounted &&
            setBalance((prev) => {
              return { ...prev, error: error, loading: false };
            });
        }
      };
      getBalance();
    }
    return () => {
      isMounted = false;
    };
  }, [user]);

  const property = data3.find((dato) => {
    return dato?.user?.data?.id === user?.property;
  });

  const activeExchangeRate = Number(curr?.value ?? 0);

  const save = async (values) => {
    setIsPending(true);
    if (cash === false) {
      const { bank_id, reference, payment_by_account } = values;

      try {
        const formData = new FormData();

        formData.append("amount", total);
        if (activeExchangeRate) formData.append("rate", activeExchangeRate);
        /*       formData.append("payment_by_account", 1); */
        formData.append("payment_by_account", payment_by_account);
        if (payment_by_account !== 1) {
          formData.append("bank_id", bank_id);
          formData.append("reference", reference);
          /*   const imageUrl = `${selectedCondominium}/${properties}/paymentProperty/${file.name}`;
            const url = `https://homelan.nyc3.digitaloceanspaces.com/${imageUrl}`; */
          if (file) formData.append("voucher", file);
        }
        formData.append(`propertyDebtsToPay[0]`, pay);

        const { code, pay_id } = await markAsPaidDebtToPayAsPropertyAdminPass(
          formData
        );
        if (code === SUCCESS_RESPONSE.CREATED) {
          collapseOneOpen(false);
          const payId = pay_id;
          setRedirectUrl(`/dashboard/${moduleBase}/${id}/pay/${payId}`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Pago emitido exitosamente, espere su aprobación.`,
          });
        }
      } catch (error) {
        handleErrorMessage(error);
        console.log(error);
      }
    }

    if (cash === true) {
      const { bank_id, reference, payment_by_account } = values;

      try {
        const formData = new FormData();

        formData.append("amount", total);
        if (activeExchangeRate) formData.append("rate", activeExchangeRate);
        /*       formData.append("payment_by_account", 1); */
        formData.append("payment_by_account", 2);
        if (payment_by_account !== 1) {
          /*    formData.append("bank_id", bank_id);
          formData.append("reference", reference); */
          /*  const imageUrl = `${selectedCondominium}/${properties}/paymentProperty/${file.name}`;
            const url = `https://homelan.nyc3.digitaloceanspaces.com/${imageUrl}`; */
          if (file) formData.append("voucher", file);
        }

        formData.append(`propertyDebtsToPay[0]`, pay);

        const { code, pay_id } = await markAsPaidDebtToPayAsPropertyAdminPass(
          formData
        );
        if (code === SUCCESS_RESPONSE.CREATED) {
          collapseOneOpen(false);
          const payId = pay_id;
          setRedirectUrl(`/dashboard/${moduleBase}/${id}/pay/${payId}`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Pago emitido exitosamente, espere su aprobación.`,
          });
        }
      } catch (error) {
        handleErrorMessage(error);
        console.log(error);
      }
    }
    setIsPending(false);
  };

  const [cuentas, setCuentas] = useState([]);
  const fetchApiCuentas = useCallback(async () => {
    try {
      const response = await fetchDebtsToPayAsPropertyCuenta(params);
      setCuentas(
        response.data && response.data.length >= 0 ? response.data : []
      );
    } catch (error) {
      setCuentas([]);
    }
  }, []);

  useEffect(() => {
    fetchApiCuentas();
  }, [fetchApiCuentas]);

  /*   useEffect(() => {
      if (selectedBankId) {
        clearErrors("bank_id");
      } else {
        setError("bank_id", {
          message: "El banco es requerido",
        });
      }
      // eslint-disable-next-line
    }, [selectedBankId]); */

  const datosFiltrados = data.filter((cuenta) => cuenta.id === Number(pay));

  const [total, setTotal] = useState(
    datosFiltrados[0]?.amount - datosFiltrados[0]?.total_paid
  );
  console.log(datosFiltrados);

  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCuenta([]);
      setSelectAll(false); // Establecer selectAll en falso al deseleccionar todas las cuentas
    } else {
      setSelectedCuenta(data2);
      setSelectAll(true);
    }
  };

  const renderBanksItems = () => {
    return condominiumBanks.map((bank, i) => {
      return (
        <SelectBankListItem
          key={i}
          id={bank.condominium_banks_id}
          selected={selectedBankId}
          onSelect={() => {
            setBank(bank);
            setSelectedBankId(bank.condominium_banks_id);
            setValue("bank_id", bank.condominium_banks_id);
          }}
          title={bank?.name}
          alternativeName="banco"
          createdAt={bank.created_at}
          owner_dni={bank.owner_dni}
          owner_name={bank.owner_name}
          account={bank.account_number}
        />
      );
    });
  };

  const renderCuentasItems = () => {
    return data.map((cuenta, i) => {
      return (
        <SelectCuentasListItem
          key={i}
          id={cuenta.id}
          selected={selectedCuenta.some((c) => c.id === cuenta.id)}
          /*     onSelect={() => {
            if (selectedCuenta.some((c) => c.id === cuenta.id)) {
              setSelectedCuenta(selectedCuenta.filter((c) => c !== cuenta));
            } else {
              setSelectedCuenta((prev) => [...prev, cuenta]);
            }
          }} */
          onSelect={() => {
            if (selectedCuenta.some((c) => c.id === cuenta.id)) {
              setSelectedCuenta(
                selectedCuenta.filter((c) => c.id !== cuenta.id)
              );
            } else {
              setSelectedCuenta((prev) => [...prev, cuenta]);
            }
          }}
          title={
            cuenta?.finance != null && cuenta?.finance?.name
              ? cuenta?.finance?.name
              : cuenta?.reserve_fund?.name
          }
          alternativeName="banco"
          createdAt={cuenta?.id}
          owner_dni={cuenta?.id}
          owner_name={
            cuenta?.finance != null && cuenta?.finance?.name
              ? cuenta?.finance?.name
              : cuenta?.reserve_fund?.name
          }
          account={cuenta?.amount}
        />
      );
    });
  };

  useEffect(() => {
    const value = selectedCuenta.reduce((a, c) => {
      return a + c.amount;
    }, 0);
    setAmount(value);
  }, [selectedCuenta]);
  /* 
  const filteredData = data.filter((payment) => payment.id === Number(pay));

  console.log(filteredData) */

  /*     const renderDebts = () => {
        return cuentas.map((debt, i) => {
            return <PropertyCuentasListItem
                key={i}
                debttopay={debt}
                alternativeName={"Cuenta por pagar"}
                options={true}
            />
        })
    } */

  /*     const renderDebts = () => {
            return cuentas.map((debt, i) => {
                return  <li>{debt.finance.name}</li>
            })
        } */

  /*     const getDate = (date) => {
        var d = new Date(date);
        return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    } */

  return (
    <Fragment>
      <PageHeader
        title="Cuentas por pagar"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
      />
      <Card
        data-testid="form"
        tag={Form}
        className="bg-transparent shadow-none"
      >
        <Row className="no-gutters">
          <Col className="pr-lg-2 mb-3" lg={8}>
            <Card>
              <CardHeader>
                <Row>
                  <Col>
                    <h5 className="mb-2 mb-md-0">Detalle de pago</h5>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="bg-light">
                <Row form>
                  <Col sm tag={FormGroup}>
                    <Label for="acronym">Origen de fondos</Label>
                    <Controller
                      name="payment_by_account"
                      control={control}
                      rules={{
                        required: {
                          value: true,
                          message: "Seleccione un fondo",
                        },
                        validate: (value) => {
                          if (amount > balance.data && current === true) {
                            return "";
                          }
                          return true;
                        },
                      }}
                      render={({ onChange, name, value }) => (
                        <Input
                          type="select"
                          name="payment_by_account"
                          id="payment_by_account"
                          value={value || "Selecciona"}
                          className={`${errors["payment_by_account"]?.message
                              ? "border-danger"
                              : ""
                            } form-select, overflow-auto`}
                          onChange={(event) => {
                            setFund(event.target.value === "2");
                            setCurrent(event.target.value === "1");
                            setCash(event.target.value === "3");
                            setValue("payment_by_account", event.target.value);
                            onChange(`${event.target.value}`);
                          }}
                        /*    onChange={handleInputChange}
                               innerRef={register({
                                 required: { value: true, message: "Ingresar el monto" },
                               })} */
                        >
                          <option value="Selecciona" disabled>
                            ---
                          </option>
                          <option value="2">Transferencia</option>
                          <option value="3">Efectivo</option>
                        </Input>
                      )}
                    />
                    <WizardError
                      error={errors["payment_by_account"]?.message}
                      className="fs--1 font-weight-normal d-block"
                    />
                  </Col>
                </Row>

                {amount > balance.data && current === true && (
                  <Row className="p-card">
                    <Col>
                      <Alert color="danger" className="mb-0">
                        No tienes saldo suficiente en la Caja para realizar el
                        pago, puedes realizar un abono ahora mismo pulsando el
                        siguiente enlace
                        <Button
                          data-testid="Button"
                          tag={Link}
                          color="link"
                          size="sm"
                          className="ml-1 pl-0"
                          to={`/dashboard/my/finance/advance/add`}
                        >
                          Abonar saldo
                        </Button>
                      </Alert>
                    </Col>
                  </Row>
                )}
                {fund === true && (
                  <Row>
                    <Col tag={FormGroup}>
                      <Label>Seleccione un banco del condominio</Label>
                      <Row>
                        <Col tag={FormGroup} xs={9} className="pr-0">
                          <Input
                            type="text"
                            placeholder="Ingrese el nombre de un banco"
                            onChange={(event) => setSearch(event.target.value)}
                          />
                        </Col>
                        <Col tag={FormGroup} xs={3}>
                          <ButtonIcon
                            className="btn-block"
                            style={{ whiteSpace: "nowrap" }}
                            icon={faSearch}
                            color="falcon-default"
                            onClick={() =>
                              setParams((prev) => {
                                return { ...prev, search: search };
                              })
                            }
                          >
                            Buscar
                          </ButtonIcon>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {!cbIsLoading ? (
                            condominiumBanks.length >= 1 ? (
                              renderBanksItems()
                            ) : (
                              <p>No se han encontrado bancos.</p>
                            )
                          ) : (
                            <Loader padding="py-3" />
                          )}
                          <FullPagination
                            nextPage={cbNextPage}
                            prevPage={cbPreviousPage}
                            goToPage={cbGoToPage}
                            meta={cbMeta}
                            className={"shadow-none"}
                            posText={"bancos"}
                            perPage={cbPerPage}
                          />
                          {!selectedBankId && (
                            <span
                              className={classNames(
                                "text-danger d-inline-block fs--1 font-weight-normal d-block"
                              )}
                            >
                              Debes seleccionar un banco
                            </span>
                          )}
                          <WizardError
                            error={errors["bank_id"]?.message}
                            className="fs--1 font-weight-normal d-block"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}
                {fund === true && (
                  <FormGroup>
                    <Label for="name">Nombre del banco</Label>
                    <Input
                      disabled
                      defaultValue={bank?.name || undefined}
                      autoComplete="off"
                      name="name"
                      id="title"
                      placeholder="Nombre del banco"
                    />
                  </FormGroup>
                )}
                {fund === true && (
                  <Row form>
                    <Col sm tag={FormGroup}>
                      <Label for="account_number">Número de cuenta</Label>
                      <NumberFormat
                        disabled
                        value={bank?.account_number || undefined}
                        format="#### #### #### #### #### #### ####"
                        placeholder="Número de cuenta"
                        className="form-control"
                        renderText={(value, props) => (
                          <div {...props}>{value}</div>
                        )}
                      />
                    </Col>
                    <Col sm tag={FormGroup}>
                      <Label for="owner_name">Nombre del propietario</Label>
                      <Input
                        disabled
                        defaultValue={bank?.owner_name || undefined}
                        autoComplete="off"
                        name="owner_name"
                        id="owner_name"
                        placeholder="Nombre del propietario"
                      />
                    </Col>
                  </Row>
                )}
                {fund === true && (
                  <Row form>
                    <Col sm tag={FormGroup}>
                      <Label for="owner_dni">Identificación (DNI)</Label>
                      <Input
                        defaultValue={bank?.owner_dni || undefined}
                        id="owner_dni"
                        name="owner_dni"
                        disabled
                        type="text"
                        placeholder="Identificación"
                      />
                    </Col>
                  </Row>
                )}
                {fund === true && (
                  <Row>
                    <Col tag={FormGroup}>
                      <FileUploadArea
                        label="Comprobante de pago"
                        accept="image/*,application/pdf"
                        onChange={(e) => {
                          const f = e.target.files[0];
                          if (f) {
                            setFile(f);
                            setImagePreview(URL.createObjectURL(f));
                          }
                        }}
                        preview={imagePreview}
                        fileName={file?.name}
                        onRemove={() => {
                          setFile(null);
                          setImagePreview(null);
                        }}
                        error={errors["voucher"]?.message}
                      />
                    </Col>
                  </Row>
                )}
                {cash === true && (
                  <Row>
                    <Col tag={FormGroup}>
                      <FileUploadArea
                        label="Comprobante de pago"
                        accept="image/*,application/pdf"
                        onChange={(e) => {
                          const f = e.target.files[0];
                          if (f) {
                            setFile(f);
                            setImagePreview(URL.createObjectURL(f));
                          }
                        }}
                        preview={imagePreview}
                        fileName={file?.name}
                        onRemove={() => {
                          setFile(null);
                          setImagePreview(null);
                        }}
                        error={errors["voucher"]?.message}
                      />
                    </Col>
                  </Row>
                )}

                {fund === true && (
                  <Row>
                    <Col tag={FormGroup}>
                      <Label>Código de referencia</Label>

                      <Input
                        className={classNames({
                          "border-danger": errors?.reference?.message,
                        })}
                        type="text"
                        name="reference"
                        id="reference"
                        /*          onChange={({ e }) => {
                          setValue("reference", e.target.value);
                          onChange(`${e.target.value}`);
                        }} */

                        innerRef={register({
                          required: "El número de referencia es obligatorio.",
                          minLength: {
                            value: 5,
                            message:
                              "El número de referencia debe tener al menos 5 caracteres.",
                          },
                        })}
                      /*    onChange={(e) => setValue("reference", e.target.value)
                  onChange(`${e.target.value}`)
                } */
                      />
                      <WizardError
                        error={errors?.reference?.message}
                        className="fs--1 font-weight-normal d-block"
                      />
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col className="pl-lg-2 mb-3" lg={4}>
            <Card className="bg-light">
              <Card>
                <CardBody className="bg-light">
                  {/*          <Row>
                  <Col>
                    <h5 className="mb-2 mb-md-0">Conceptos</h5>
                  </Col>
                </Row> */}
                  <Table className="m-0 p-0">
                    <thead>
                      <tr>
                        <th>Concepto</th>
                        <th>Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map(
                        (cuenta, i) =>
                          cuenta.id === Number(pay) && (
                            <tr key={i}>
                              <td>
                                {cuenta.finance !== null
                                  ? cuenta.finance.name
                                  : cuenta.reserve_fund.name}
                              </td>
                              <td>
                                <NumberFormat
                                  className="text-nowrap"
                                  thousandSeparator={true}
                                  prefix={`${baseCurrency.symbol} `}
                                  displayType="text"
                                  value={
                                    cuenta.amount
                                      ? Number(cuenta.amount).toFixed(2)
                                      : "0.00"
                                  }
                                />
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </Table>

                  <hr />
                  <p className="mb-0 font-weight-semi-bold">Total a pagar</p>
                  <Row className="align-items-center py-2">
                    <Col>
                      {/*   <NumberFormat
                      value={datosFiltrados[0]?.amount}
                      prefix={`${baseCurrency.symbol} `}
                      className="form-control text-nowrap"
                      fixedDecimalScale
                      decimalScale={2}
                      thousandSeparator
                      disabled
                    /> */}
                      <NumberFormat
                        prefix={`${baseCurrency.symbol} `}
                        className="form-control"
                        onValueChange={({ value }) => {
                          setTotal(value);
                        }}
                        isAllowed={({ floatValue }) => {
                          if (
                            floatValue >
                            datosFiltrados[0]?.amount -
                            datosFiltrados[0]?.total_paid
                          ) {
                            return false;
                          }
                          return true;
                        }}
                        allowEmptyFormatting // Permite eliminar el número
                        fixedDecimalScale
                        decimalScale={2}
                        thousandSeparator
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <span className="fs--1 text-danger mb-2">
                        Monto máximo:{" "}
                        <NumberFormat
                          className="text-nowrap"
                          value={
                            datosFiltrados[0]?.amount -
                            datosFiltrados[0]?.total_paid
                          }
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          prefix={`${baseCurrency.symbol} `}
                          displayType="text"
                        />
                      </span>
                    </Col>
                  </Row>
                  <ButtonIcon
                    color="primary"
                    icon={faDollarSign}
                    onClick={() => collapseOneOpen(!collapseOne)}
                    className="btn-block"
                  >
                    Emitir pago
                  </ButtonIcon>
                </CardBody>
              </Card>
            </Card>
          </Col>
        </Row>
      </Card>
      <Modal isOpen={collapseOne} data-testid="modal">
        <ModalHeader>Confirmación</ModalHeader>
        <ModalBody>
          <p className="mb-0 font-weight-bold fs--1">
            ¿Está seguro de que ingresó todos los datos correctamente? Esta
            información no puede ser cambiada posteriormente.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isPending} onClick={() => collapseOneOpen(!collapseOne)}>
            Cancelar
          </Button>
          <Button
            data-testid="submit-button"
            color="primary"
            type="submit"
            disabled={isPending}
            onClick={handleSubmit(save)}
          >
            {isPending && <Spinner size="sm" className="mr-2" />}
            Sí, pagar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default withRedirect(PropertyToPaysAdmin);
